import { Component, OnInit, Input } from '@angular/core';
import { ProfileService } from '../../services/profile.service';
import { SelectSupplierContactList } from '../../store/app.selector';
import { Store } from '@ngrx/store';
import { SupplierState } from '../../store/state/supplierstate.state';
import { SupplierContactPropertyValue } from '../../models/supplier.model';
import { CommonService } from 'app/profile/services/common.service';
import { AppSettings } from '../../../app.settings';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
    @Input() suppliercode: string;
    supplierHold: boolean = false;
    preventativeHold: boolean = false;
    rejectionReason: string;
    holdType: string;
    financeLeadContact: string;
    primaryContact: string;
    contacts: SupplierContactPropertyValue[];
    @Input() showPendingContractTaskBanner: boolean = false;

    constructor(private profileSerice: ProfileService,
        private store: Store<SupplierState>,
        private config: AppSettings,
        private commonService: CommonService
    ) {
    }

    ngOnInit() {
        if (this.suppliercode) {
            this.profileSerice.getSupplierPaymentActiveHold(this.suppliercode).subscribe(response => {
                if (response) {
                    this.supplierHold = true;
                    this.rejectionReason = response.holdName;
                    this.holdType = response.holdType;
                }
            });
            this.profileSerice.getPreventativeStatus(this.suppliercode).subscribe(response => {
                if (response) {
                    this.preventativeHold = response;
                }
            });
            this.store.select(SelectSupplierContactList).subscribe(res => {
                if (res) {
                    this.contacts = res;
                    var financeLeadContact = this.contacts.find(x => x.types.newValue.includes("Finance Lead"));
                    var primaryContact = res.find(x => x.types.newValue.includes("Primary"));
                    if (financeLeadContact) {
                        this.financeLeadContact = `${financeLeadContact.firstName.newValue} ${financeLeadContact.lastName.newValue}`;
                    }
                    if (primaryContact) {
                        this.primaryContact = `${primaryContact.firstName.newValue} ${primaryContact.lastName.newValue}`;
                    }
                }
            })
        }
    }

    navigateToTasks() {
        window.open(`${this.config.SRM_UI_URL}tasks`, '_blank');
    }
}
